import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Sgke302aRequest, Sgke302aResponseSearchResultList, Sgke903aRequest,
  Sgke903aResponseCompanyAreaInfo,
  Sgke903aResponseInitialhyojiInfo,
  Szza012aRequest
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { UsedSgke302aService } from '../../services/used-sgke302a.service';

@Component({
  selector: 'app-sgke300d',
  templateUrl: './sgke300d.component.html',
  styleUrl: './sgke300d.component.scss'
})
export class Sgke300dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** FormGroup */
  searchReqForm: UntypedFormGroup = this.fb.group({});
  /** 検索結果情報 */
  searchResultList: Array<Sgke302aResponseSearchResultList>;
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 業務日付 */
  businessDate: Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;

  /** 画面ID */
  private static GAMEN_ID = 'SGKE300D';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 検索済フラグ */
  get searched(): boolean {
    return this.searchResultList?.length > 0;
  }

  /**
   * コンストラクタ
   * @param {UsedSgke302aService} searchService 
   * @param {UsedSgke903aService} companyAreaInfoService 
   * @param {UntypedFormBuilder} fb 
   * @param {ResponseMsgUtils} responseMsgUtils 
   * @param {ChangeDetectorRef} cd
  * @memberof Sgke300dComponent
   */
  constructor(
    public searchService: UsedSgke302aService,
    public getDateService: UsedSzza012aService,
    private companyAreaInfoService: UsedSgke903aService,
    private timeApiService: TimeApiService,
    private fb: UntypedFormBuilder,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
  }

  /**
   * 初期処理
   */
  ngOnInit(): void {
    this.searchReqForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    this.companyAreaInfo();

    this.getBusinessDate();
  }

  /**
   * 終了処理
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   */
  companyAreaInfo() {
    let requestInfo: Sgke903aRequest = {
      requestCommon: undefined,
      reqBusinessArea: {
        gamenId: Sgke300dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.responseBusinessArea) {
          this.cmpnyAreaList = response.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response.responseBusinessArea.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      }, error => {
      });

  }

  /**
  * 業務日付取得
  */
  getBusinessDate() {
    // SZZA012Aのリクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.getDateService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          if (response?.todayDay) {
            this.businessDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        },
        (error) => {
        }
      );
  }

  /**
   * 検索処理
   */
  search(): void {
    this.clearErrorMsg();

    this.searchResultList = null;
    //画面から検索キーを取得し、リクエストに反映。
    let request = this.searchReqForm.getRawValue() as Sgke302aRequest;
    //検索処理実施
    this.searchService.doSgke302a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {
          this.searchResultList = response.searchresultList;
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }
      }, error => {
      });

  }

  /**
   * クリアボタン押下処理
   */
  clear(): void {
    this.clearErrorMsg();
    this.searchResultList = null;
  }

  /**
   * 請求ポータル画面への遷移
   * @param row 選択している行情報
   */
  navigateBill(row: Sgke302aResponseSearchResultList): void {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '8';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke300dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

}
